import fetchProjectTargetAmounts from '../../../Components/TargetCosts/Services/fetchProjectTargetAmounts'

export default () => (dispatch) => {
  dispatch(fetchProjectTargetAmounts())
}
